<template>
  <div class="content">
        <p class="title">数字证书服务协议</p>
        <p>
          声明：<br/>
          1. 您应当认真阅读并遵守《数字证书服务协议》（以下简称“本协议”），本协议具有合同效力，当您勾选确认并完成全部注册程序后即成立生效。
<br/>
2. 请您务必审慎阅读、充分理解各条款内容，特别是权利条款、免责条款和争议解决条款。如您对本协议有任何疑问或对任何条款不能准确理解的，请不要进行后续操作。
<br/>
3. 您承诺接受并遵守本协议的约定，届时您不可以未阅读本协议内容或未获得问询解答等理由，主张本协议无效，或要求撤销本协议。
本协议是电子认证服务及申请数字证书，相关方与您签署的服务协议。本平台及合作CA机构的各项服务，本协议具有合同效力，您勾选确认即代表本协议成立并生效。
        </p>
        <h5>一、数字证书服务简介</h5>
        <div>
          1. 重庆易保全网络科技有限公司与工信部认可的电子认证中心（简称CA机构）合作（包括但不限于：天威诚信、大陆云盾、程远未来等），为自然人、法人或依法成立的其他组织提供身份实名验证服务并颁发数字证书，提供电子文件签署服务。
<br/>2. 鉴于您要使用数字证书进行电子签名，您同意通过重庆易保全网络科技有限公司合作的CA机构进行电子认证、申请数字证书，并同意重庆易保全网络科技有限公司将您的身份信息提供给合作的CA机构用于电子认证服务、CA机构可基于此受理您的申请并为您制作签发数字证书。
<br/>3. 为明确相关的权利和义务，数字证书申请主体和CA机构及本平台就数字证书达成本协议。
<br/>4. 本协议中的“证书”指自然人的个人证书或法人/其他组织的证书。
        </div>
        <h5>二、名词解释</h5>
        <div>
          <strong>1. 订户：</strong><br/>
          指通过君子签从合作的权威第三方数字认证中心（CA机构）申请获得数字证书的自然人、法人或依法成立的其他组织机构。<br/>
          <strong>2. 数字证书：</strong><br/>
          是指一段信息，它至少包含了一个名字，标识特定的CA或标识特定的订户，包含了订户的公钥、证书有效期、证书序列号，及CA数字签名。<br/>
          <strong>3. 证书私钥：</strong><br/>
          数字证书包含证书本身和一个密钥对，密钥对的一部分是公钥，另一部分称为私钥。公钥公之于众，谁都可以使用。私钥只有自己知道，一般信息都是由公钥进行加密，相对应的私钥进行解密。<br/>
        </div>
        <h5>三、订户的权利和义务</h5>
        <div>
          1. 您应按照君子签合作CA机构规定的证书申请流程向其提供有关资料，并保证所填写的注册信息和所提供的资料的真实性、准确性和完整性，否则CA机构或君子签有权拒绝您的申请请求。
<br/>2. 您的证书信息在证书有效期限内变更的，应当及时书面告知君子签平台，并终止使用该证书。
<br/>3. 若您为法人或其他组织用户，您的分立、合并、解散、注销、宣告破产或倒闭，或被撤销营业执照等主体资格终止的，应于上述情况发生时的5个工作日内通过书面形式告知君子签申请撤销数字证书，并终止使用该证书，否则，因未尽该通知义务给君子签造成损失的，由您全部赔偿。
<br/>4. 您同意君子签平台及合作的CA机构向有关部门和个人核实您的信息。君子签平台及合作的CA机构应合法地收集、处理、传递及应用您的资料，按照国家有关规定及本协议的约定予以保密。
<br/>5. 您对证书享有独立的使用权。您使用证书产生的权利，由您享有；您使用证书产生的义务、责任，由您承担。
6. 您应当妥善保管证书私钥。因您原因致使证书私钥泄露、损毁或者丢失的，损失由您承担。<br/>
        </div>
        <h5>四、证书的使用、更新、吊销</h5>
        <div>
          1. 本证书只能在有效期限内、在君子签平台上使用。证书有效期限届满，您应另行申请数字证书更新。<br/>
2. 本协议的有效期限为证书的有效期限。证书期限届满，证书更新的，本协议有效期限顺延至证书更新期限届满日。<br/>
3. 证书私钥在证书有效期内损毁、丢失、泄露的，您应当及时申请办理吊销手续，吊销自手续办妥时起生效，吊销生效前发生的损失由您承担。<br/>
4. 您知悉证书私钥已经丢失或者可能已经丢失时，应当及时告知君子签平台，协助完成吊销该证书的工作，并终止使用该证书。<br/>
        </div>
        <h5>五、君子签平台及合作CA的权利</h5>
        <div>
          <strong>您有下列情形之一，君子签平台及合作的CA机构有权申请吊销证书并不承担任何责任。由此给君子签平台及合作CA机构造成损失的，您应当向君子签平台及合作CA机构承担赔偿责任：</strong><br/>
          1. 您向君子签平台及合作CA机构提供的资料或者信息不真实、不完整或者不准确的。<br/>
2. 您证书的信息有变更，未终止使用该证书并通知君子签平台及合作CA机构的。<br/>
3. 您知悉证书私钥已经丢失或者可能已经丢失时，未终止使用该证书并通知君子签平台及合作CA机构的。<br/>
4. 您超过证书的有效期限及应用范围使用证书的。<br/>
5. 您产生分立、合并、解散、注销、宣告破产或倒闭，被撤销营业执照等主体资格终止的。<br/>
6. 您使用证书用于违法、犯罪活动的。<br/>
        </div>
        <h5>六、免责条款</h5>
        <div>
        1. 因设备故障、电力故障及通讯故障或者电脑病毒、自然灾害等因素造成您损失的，君子签平台及合作CA机构不承担任何责任。<br/>
2. 由于电子认证中心的原因导致证书私钥被破译、窃取，致使您遭受损失的，由电子认证中心向您承担赔偿责任。<br/>
        </div>
        <h5>七、协议的终止</h5>
        <div>
          <strong>有下列情形之一的，本协议终止：</strong><br/>
          1. 您证书期限届满。<br/>
2. 您证书被吊销。<br/>
3. 您向君子签平台及合作CA机构申请终止本协议，君子签平台及合作CA机构同意的。<br/>
4. 相关方协商终止本协议的。<br/>
5. 依据法律、法规等规定，本协议应当终止的。<br/>
        </div>
        <h5>八、争议解决条款</h5>
        <div>
          因本协议产生的争议，不论争议金额大小，均提交重庆仲裁委员会适用重庆仲裁委员会仲裁规则项下的简易程序进行仲裁。仲裁裁决为终局的，对各方均有拘束力。 
        </div>
        <h5>附录：</h5>
        <p>天威诚信认证业务规则：<a href="https://www.itrus.com.cn/certificate.html" target="_blank" rel="noopener noreferrer">https://www.itrus.com.cn/certificate.html</a></p>
        <p>大陆云盾数字证书服务协议：<a href="https://www.mcsca.com.cn/cps_catalog.html?index=CPS" target="_blank" rel="noopener noreferrer">https://www.mcsca.com.cn/cps_catalog.html?index=CPS</a></p>
        <p>程远未来电子认证业务规则：<a href="https://www.ifutureca.com/about_BS.html" target="_blank" rel="noopener noreferrer">https://www.ifutureca.com/about_BS.html</a></p>
      </div>
</template>

<script>
  export default {
    methods: {
    },
    mounted() {
    },
    data() {
      return {
      };
    },
    computed: {
    },
  };
</script>

<style lang="less" scoped>
.title {
  font-size: 18px;
  text-align: center;
  line-height: 1.5;
  margin: 10px 0;
}

.content {
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  font-stretch: normal;
  font-size: 12px;
  font-family: "Microsoft YaHei", Arial;
  line-height: 24px;
  color: rgb(91, 91, 91);
  display: block;
}
</style>



// WEBPACK FOOTER //
// components/protocol/pItems/Number.vue